import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { Button, Confirm } from "react-admin";

import { AddIcon } from "../../../../components/common/iconography";
import { deepRedirect } from "../../../../utils/utils";
import { InventoryStatus } from "../../../../utils/constants";

export const CreateInventoryItemButton = ({
  backPath,
  form,
  inventory,
  ...props
}) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const handleCreate = () => {
    const formState = form.getState();

    if (formState.dirty) {
      setOpen(true);
    } else {
      handleConfirm();
    }
  };

  const handleDialogClose = () => setOpen(false);
  const handleConfirm = () => {
    deepRedirect(history, "/inventoryItems/create", backPath, {
      inventory: inventory,
    });
  };

  if (!inventory || inventory.status === InventoryStatus.SHIPPED) return null;
  return (
    <>
      <Button label="Add" color="default" onClick={handleCreate}>
        <AddIcon />
      </Button>
      <Confirm
        isOpen={open}
        title="Save Confirmation"
        content="You have un-saved Inventory changes. If you continue, all changes will be lost. Proceed?"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};
